import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader, Col, Row, Spinner } from 'reactstrap'

import DocumentContentWidget from './partials/DocumentContentWidget'
import DocumentDetailsWidget from './partials/DocumentDetailsWidget'

import ModelCategoriesWidget from '../Categories/ModelCategoriesWidget'

import { getDocument } from './services'
import { handleError } from '../../helpers'

export default function DocumentProfile(props) {
	const id = props.match.params.id
	const [document, setDocument] = useState(null)
	const [reload, setReload] = useState(true)

	useEffect(() => {
		reload && getDocument(id, {
			include: 'categories'
		})
			.then(res => setDocument(res.data.data))
			.catch(error => handleError(error))
			.finally(() => setReload(false))
	}, [ reload, id ])

	if(!document) return <Spinner />

	const morphProps = {
		model: document,
		modelType: "document",
		reload: () => setReload(true)
	}

	return (
		<React.Fragment>
			<Row>
				<Col md="4">
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Detalles Generales</h6>
						</CardHeader>
						<CardBody>
							<DocumentDetailsWidget document={document} reload={() => setReload(true)} />
						</CardBody>
					</Card>
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Categorías de Documentos</h6>
						</CardHeader>
						<CardBody>
							<ModelCategoriesWidget {...morphProps} />
						</CardBody>
					</Card>
				</Col>
				<Col>
					<Card>
						<CardHeader>
							<h6 className='mb-0'>Datos del Documento</h6>
						</CardHeader>
						<CardBody>
							<DocumentContentWidget document={document} />
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	)
}